import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { EuiProvider } from '@elastic/eui';
import Amplify, { Auth } from 'aws-amplify';
import config from './aws-exports';
import awsconfig from './awsconfig';
import awsauth from './awsauth';
Amplify.configure(config);
Amplify.configure(awsconfig);
awsauth.redirectSignIn = `${window.location.origin}/`;
awsauth.redirectSignOut = `${window.location.origin}/`;
Auth.configure({ oauth: awsauth });

ReactDOM.render(
  <React.StrictMode>
    <EuiProvider colorMode="light">
      <App />
    </EuiProvider>
  </React.StrictMode>,
  document.getElementById('root')
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
